import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { ApplicationState, reducers } from './';

export default function configureStore(
    routerMiddleware: any,
    routerReducer: any,
    initialState?: ApplicationState,
) {
    const middleware = [thunk, routerMiddleware];

    const rootReducer = combineReducers({
        ...reducers,
        router: routerReducer,
    });

    const enhancers = [] as any[];
    const windowIfDefined = typeof window === 'undefined' ? null : (window as any);
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers),
    );
}
